<div class="flex justify-center flex-col items-center h-full w-full rounded-[4px]">
  <div *ngIf="showImage" class="background-img w-60 my-0 mx-auto block mix-blend-luminosity"></div>
  <div *ngIf="!!text" class="font-primary-medium text-sm text-grey-800 mb-4">{{ text }}</div>
  <div *ngIf="subtext" class="font-primary max-w-2xl text-xs text-grey-500 text-center" [ngClass]="{ '!text-sm': !text }">{{ subtext }}</div>
</div>
